import React from 'react';
import styled from 'styled-components';

const BackgroundContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -2;
  background-image: url(${process.env.PUBLIC_URL + '/img/imagebackground/bgimg2.jpg'});
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(245, 248, 250, 0.7);
  z-index: -1;
`;

const BackgroundWrapper = ({ children }) => {
  return (
    <>
      <BackgroundContainer />
      <Overlay />
      {children}
    </>
  );
};

export { BackgroundContainer, Overlay };
export default BackgroundWrapper;
